import commons from './commons';
import services from './services';

export default { ...commons, ...services };
